import { CircularProgress } from "@mui/material";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Messages } from "../messages";
import { Message } from "../reducers/session";

export default function MessageBody({ message, isIdentifying }: { message: Message; isIdentifying: boolean }): JSX.Element {
    if (message) {
        if (message.device) {
            return <FormattedMessage {...Messages.DeviceRetry} />;
        } else if (message.userMessage || message.userMessageHeader) {
            return <>{message.userMessage}</>;
        } else if (message.systemMessage && message.systemMessage.id == "AuthenticationErrors.AccessDenied") {
            return <FormattedMessage {...message.systemMessage} values={{ ip: message.systemMessage.values.values }} />;
        } else if (message.systemMessage) {
            return <FormattedMessage {...message.systemMessage} />;
        }
    } else if (isIdentifying) {
        return <div className="progress2"><CircularProgress /></div>;
    }

    return null;
}